<template>
  <page>
    <div>
      <v-flex xs12>
        <form>
          <v-expansion-panels>
          <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xl3 lg6 xs6>
                        <v-text-field v-model="filters.discLdg" :label="labels.discLdg" :error-messages="errors.collect('discLdg')" data-vv-name="discLdg" :data-vv-as="labels.discLdg" v-validate="'name|max:2'"></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg6 xs6>
                        <v-text-field v-model="filters.discLdgDesc"  :label="labels.discLdgDesc" :error-messages="errors.collect('discLdgDesc')" data-vv-name="discLdgDesc" :data-vv-as="labels.discLdgDesc" v-validate="'name|max:35'"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="doNewDiscLdg()">
            New Discount / Loading <v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-card>
          <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
            <template v-slot:item="row"><tr>
              <td>{{ row.item.discLdg }}</td>
              <td>{{ row.item.discLdgDesc }}</td>
              <td>{{ row.item.discLdgPct }}</td>
              <td class="table-action-header">
                <table-action :rowData="row" review @review="doStdRiskTxtReview(row.item.discLdg)" query @query="doStdRiskTxtQuery(row.item.discLdg)" remove @remove="doPromptRemove(row.item)"></table-action>
              </td></tr>
            </template>
          </v-data-table>
        </v-card>
      </v-card>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete?
      </confirm>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'

export default {
  data() {
    return {
      toogleArray: [false],
      headers: [
        { text: 'Type', align: 'left', value: 'discLdg' },
        { text: 'Description', value: 'discLdgDesc' },
        { text: '%', value: 'discLdgPct' },
        TableConst.tableActionHeader
      ],
      labels: {
        discLdg: 'Type',
        discLdgDesc: 'Description',
        discLdgPct: '%'
      },
      filters: {
        discLdg: undefined,
        discLdgDesc: undefined
      },
      totalItems: 0,
      selectedDiscLdg: undefined,
      deleteDiscLdg: '',
      loading: false,
      promptRemove: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  computed: {
    discLdgMenu() {
      return this.$store.state.discLdgParam.menu
    }
  },
  methods: {
    async doInit(options) {
      this.resetMessages()
      const apiURI = this.discLdgMenu.getDiscLdgList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((discLdgDatamap) => {
                const convertList = {
                  discLdg: discLdgDatamap.discLdg,
                  discLdgDesc: discLdgDatamap.discLdgDesc,
                  discLdgPct: discLdgDatamap.discLdgPct
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.discLdg = null
      this.filters.discLdgDesc = null
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    doNewDiscLdg() {
      this.$router.push({ name: 'discLdgReview', params: { discldg: 'new', discLdgMode: 'New' } })
    },
    doStdRiskTxtReview(discldg) {
      this.$router.push({ name: 'discLdgReview', params: { discldg: discldg, discLdgMode: 'Review' } })
    },
    doStdRiskTxtQuery(discldg) {
      this.$router.push({ name: 'discLdgReview', params: { discldg: discldg, discLdgMode: 'Query' } })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedDiscLdg = data
        this.deleteDiscLdg = data.discLdg
      }
    },
    async doRemove() {
      const apiURI = this.discLdgMenu.deleteDiscLdg
      if (apiURI) {
        const expand = this.selectedDiscLdg
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(true)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    }
  },
  created() {},
  mounted() {
    this.doInit(true)
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
